<template>
  <div class="">
    <Modal
      v-model="templateListModal"
            width="600"
            :title="templateTitle"
            :mask-closable="false"
            :loading="loading"
            @on-ok="templateList('templateListForm')"
        >
      <Form
        ref="templateListForm"
        :model="templateListForm"
        :rules="ruleValidate"
        :label-width="120"
        label-position="left"
      >
        <FormItem label="模板数量"
          prop="templateNumber"
          label-for="templateNumber"
        >
          <Input
            placeholder="模板数更改"
            element-id="templateNumber"
            v-model="templateListForm.templateNumber"
          >
            
          </Input>  
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  props: {
    agentId: {
      type: Number
    },
    templateTitle: {
      type: String
    },
    templateModal: {
      type: Boolean,
      required: true
    },
    templateRow: {
      type: Object
    }
  },
  data () {
    const validateNumber = (rule, value, callback) => {
      if (!value.match(/^\d+$/)) {
        callback(new Error('只能输入数字'))
      } else {
        callback()
      }
    }
    return {
      loading: true,
      visible: false,
      templateListModal: this.templateModal,
      templateListForm: {
        epId: '',
        templateNumber: ''
      },
      ruleValidate: {
        templateNumber: [
        { required: true, message: '请输入模板数量', trigger: 'blur' },
        { validator: validateNumber, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
   // 保存编辑数据
    templateList (val) {
      this.loading = false
      setTimeout(() => {
        this.loading = true
      }, 50)
      this.$refs[val].validate((valid) => {
        if (valid) {
          let data = {
            epId: this.templateRow.id,
            ordertype_tmpl_limit_num: this.templateListForm.templateNumber
          }
          let url = '/enterprise/mgr/updateTmplCount'
          this.$http.post(url, data).then(res => {
            if (res.success) {
              let msg = '修改成功'
              this.$Message.success(msg)
              this.templateListModal = false
              this.$emit('callback')
            } else {
              this.$Message.error(res.message)
            }
          })
        }
      })
    },
    reload () {
      this.agentId = this.templateRow.id
      this.templateListForm.epId = this.templateRow.id
      this.templateListForm.templateNumber = this.templateRow.ordertype_tmpl_limit_num + ''
    }
  },
  watch: {
    templateModal (val) {
      this.templateListModal = val
      if (val) {
        this.reload()
      }
    },
    templateListModal (val) {
      if (!val) {
        this.$emit('backeditModal')
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/customManage/followCustomList/TemplateNumberChange.vue